export const USER_VIEWS_DETAILS_FETCH = "userviews/userViews_list_fetch"
export const USER_VIEWS_DETAILS_FETCH_SUCCESS =
    "userviews/userViews_list_fetch_success"

export const USER_VIEWS_SAVE = "userviews/userViews_save"
export const USER_VIEWS_SAVE_SUCCESS = "userviews/userViews_save_success"

export const USER_VIEWS_UPDATE = "userviews/userViews_update"
export const USER_VIEWS_UPDATE_SUCCESS = "userviews/userViews_update_success"

export const USER_VIEWS_DELETE = "userviews/userViews_delete"
export const USER_VIEWS_DELETE_SUCCESS = "userviews/userViews_delete_success"

export const USER_VIEW_CREATED_OR_UPDATED_RECENTLY =
    "userviews/created_or_updated_recently"

export const USER_VIEW_CLEAR_ALL = "userviews/clear_all"
export const TOGGLE_VIEW_MANAGER_NOTIFICATION =
    "userviews/toggle_view_manger_notification"
